import { loadWholeState, saveState } from './storage'
import { useEffect, useState } from 'react'
import './style.scss'

const AppLogin = ({ login }) => {
  const [checkbox, setCheckbox] = useState(false)
  const [passwd, setPasswd] = useState('')

  useEffect(() => {
    const key = loadWholeState()
    if (key === process.env.REACT_APP_PASSWORD) login(true)
  }, [login])

  const change = e => {
    const { value } = e.target
    if (value === '\n') return
    if (value === process.env.REACT_APP_PASSWORD) {
      saveState(value, !checkbox)
      login(true)

    } else setPasswd(e.target.value)
  }

  return (
    <div className='app__login'>
      <i className='icon icon--logo s32' />
      <div className='login__main'>
        <div className='login__title'>Wpisz tajny kod:</div>
        <div className='login__form'>
          <input
            type='text'
            value={passwd}
            onChange={change} />

          <div className='login__checkbox'>
            <label htmlFor='login_checkbox'>Zapamiętaj mnie</label>
            <input
              id='login_checkbox'
              type='checkbox'
              checked={checkbox}
              onChange={() => setCheckbox(!checkbox)} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AppLogin